import { useEffect } from 'react';

export function HsAnalytics() {
  useEffect(() => {
    const key = import.meta.env.VITE_HS_ANALYTICS_KEY;
    const endpoint = import.meta.env.VITE_HS_ANALYTICS_ENDPOINT;
    if (!key || !endpoint) {
      return undefined;
    }
    const script = document.createElement('script');
    script.src = '/analytics/hs-analytics.js';
    script.defer = true;
    script.onload = () => {
      if (window.HsAnalytics && typeof window.HsAnalytics.init === 'function') {
        window.HsAnalytics.init({
          key,
          endpoint,
          requireConsent: true,
        });
      }
    };
    document.body.appendChild(script);
    return () => {
      script.remove();
    };
  }, []);
  return null;
}
